import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import updated_logo from "@/assets/logo/logo_white.png";

interface PreloaderProps {
  onComplete: () => void;
}

const Preloader: React.FC<PreloaderProps> = ({ onComplete }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const logoRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const tl = gsap.timeline({
      defaults: { ease: "power2.out" },
      onComplete: onComplete,
    });

    tl.to(logoRef.current, { opacity: 1, scale: 1, duration: 1 })
      .to(logoRef.current, {
        opacity: 0,
        scale: 0.8,
        duration: 0.8,
        delay: 0.5,
      })
      .fromTo(
        textRef.current,
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 1 },
        "-=0.3",
      )
      .to(textRef.current, { opacity: 0, duration: 0.8, delay: 0.7 })
      .to(containerRef.current, { opacity: 0, duration: 0.6 });
  }, [onComplete]);

  return (
    <div
      ref={containerRef}
      className="fixed inset-0 z-[9999999] flex flex-col items-center justify-center bg-black text-white"
    >
      <div
        ref={logoRef}
        className="font-bold opacity-0 scale-75 transition-all"
      >
        <img src={updated_logo} className="w-[12rem] md:w-[18rem]" alt="logo" />
      </div>
      <div ref={textRef} className="text-lg md:text-3xl opacity-0 uppercase max-w-[200px] sm:max-w-full text-center">
        Good advice Truly <span className="text-green-300"> personalized</span>
      </div>
    </div>
  );
};

export default Preloader;
